import { useMemo } from 'react';

import type { ClassificationOption } from '@atlassian/data-classification-level';

import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import type { ClassificationLevel } from '../ClassificationRadioOption';

import { useOrgDefaultClassificationLevelId } from './useOrgDefaultClassificationLevelId';
import { useSpaceDefaultClassificationLevelOption } from './useSpaceDefaultClassificationLevelOption';

export type UseComputeDefaultOptionProps = {
	getClassificationLevelFromId: (id?: string | null) => ClassificationLevel | undefined;
	spaceDefaultClassificationLevel?: ClassificationLevel | null;
	skipQuery?: boolean;
};

export type UseComputeDefaultOptionType = {
	defaultClassificationOption: ClassificationOption;
	loading: boolean;
	error?: ApolloErrorInterop;
};

export const useComputeDefaultClassificationDropdownOption = ({
	getClassificationLevelFromId,
	spaceDefaultClassificationLevel,
	skipQuery = false,
}: UseComputeDefaultOptionProps): UseComputeDefaultOptionType => {
	const {
		orgDefaultClassificationLevelId,
		orgDefaultClasificationLoading,
		orgDefaultClassificationError,
	} = useOrgDefaultClassificationLevelId({ skip: skipQuery });

	const orgDefaultClassificationLevel = getClassificationLevelFromId(
		orgDefaultClassificationLevelId,
	);

	const defaultLevel = useMemo(() => {
		return spaceDefaultClassificationLevel || orgDefaultClassificationLevel;
	}, [spaceDefaultClassificationLevel, orgDefaultClassificationLevel]);

	const defaultClassificationOption = useSpaceDefaultClassificationLevelOption(defaultLevel);

	return {
		defaultClassificationOption,
		loading: orgDefaultClasificationLoading,
		error: orgDefaultClassificationError,
	};
};
